import { fetchTariffs } from '../../../services/api/tariff';

export const tariff = {
    namespaced: true,
    state: {
        isFetching: false,
        tariffs: [],
    },
    mutations: {
        save(state, data) {
            const filteredData = data.filter(tariff => !tariff.isBase)
            state.tariffs = filteredData;
        },
        fetching(state, isFetching) {
            state.isFetching = isFetching;
        }
    },
    actions: {
        fetchTariffs({ commit, dispatch }) {
            commit('fetching', true);

            return fetchTariffs()
                .then((res) => {
                    commit('save', res.data);
                    commit('fetching', false);
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });
                    commit('fetching', false);

                    return Promise.reject(res);
                });
        },
    },
    getters: {
        tariffs({ tariffs }) {
            return tariffs;
        },
        fetching({ fetching }) {
            return fetching;
        },
        isFetched({ tariffs }) {
            return tariffs.length > 0;
        },
        objectTariffs({ tariffs }) {
            return tariffs.reduce((newTariffs, tariff) => {
                newTariffs[tariff.id] = tariff;
                return newTariffs;
            }, {});
        },
    },
};



// WEBPACK FOOTER //
// ./src/modules/home/tariff/store.js